/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyControlPanelCounselingAutoPrinterTypename = "PharmacyControlPanelCounselingAutoPrinter" as const;

/**
 *
 * @export
 * @interface PharmacyControlPanelCounselingAutoPrinter
 */
export interface PharmacyControlPanelCounselingAutoPrinter {
  /**
   *
   * @type {string}
   * @memberof PharmacyControlPanelCounselingAutoPrinter
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyControlPanelCounselingAutoPrinter
   */
  page?: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyControlPanelCounselingAutoPrinter
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyControlPanelCounselingAutoPrinter
   */
  url?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyControlPanelCounselingAutoPrinter
   */
  readonly __typename?: string;
}

export function PharmacyControlPanelCounselingAutoPrinterFromJSON(
  json: any
): PharmacyControlPanelCounselingAutoPrinter {
  return PharmacyControlPanelCounselingAutoPrinterFromJSONTyped(json, false);
}

export function PharmacyControlPanelCounselingAutoPrinterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyControlPanelCounselingAutoPrinter {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyControlPanelCounselingAutoPrinterTypename,

    name: !exists(json, "name") ? undefined : json["name"],
    page: !exists(json, "page") ? undefined : json["page"],
    type: !exists(json, "type") ? undefined : json["type"],
    url: !exists(json, "url") ? undefined : json["url"],
  };
}

export function PharmacyControlPanelCounselingAutoPrinterToJSON(
  object?: PharmacyControlPanelCounselingAutoPrinter | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    name: value.name,
    page: value.page,
    type: value.type,
    url: value.url,
  };
}
